import { TransformationTypesEnum } from '@y42/json-schema';
import type { DataModelGoJSLink, DataModelGoJSModel, DataModelGoJSNode } from '@y42/ui-model';

export const findInputTables = (outputTableName: string, diagramModel: DataModelGoJSModel): string[] => {
  const inputTables: string[] = [];

  const output = diagramModel.nodeDataArray.find((n) => {
    const node = n as DataModelGoJSNode;
    return node.category === TransformationTypesEnum.Output && node.transformationStep.title === outputTableName;
  });

  if (!output) {
    return inputTables;
  }

  const outputNode = diagramModel.nodeDataArray.find((node) => node.key === output.key);

  const outputNodeData = outputNode as DataModelGoJSNode;
  if (!outputNodeData || outputNodeData.category !== TransformationTypesEnum.Output) {
    return inputTables;
  }

  const findInputs = (nodeData: DataModelGoJSNode) => {
    if (nodeData.category === TransformationTypesEnum.Input) {
      const inputTransformObject = nodeData.transformationStep.transformObject as { table?: string };

      const inputTableName = inputTransformObject?.table || '';

      if (inputTableName && !inputTables.includes(inputTableName)) {
        inputTables.push(inputTableName);
      }

      return;
    }

    const nodeKeysInto = diagramModel.linkDataArray
      .filter((link) => (link as DataModelGoJSLink).to === nodeData?.key)
      .map((link) => (link as DataModelGoJSLink).from);
    nodeKeysInto.forEach((nodeKey) => {
      const foundNodeData = diagramModel.nodeDataArray.find((node) => node.key === nodeKey);
      if (foundNodeData) {
        findInputs(foundNodeData as DataModelGoJSNode);
      }
    });
  };

  findInputs(outputNodeData);

  return inputTables;
};
